//invoices
const Invoices = () => import("Modules/sales/invoices/views/Invoices");
const CreateInvoice = () => import("Modules/sales/invoices/views/CreateInvoice");
const Invoice = () => import("Modules/sales/invoices/views/Invoice");

// ROUTE OPTION - `pathToRegexpOptions: { strict: true }` makes trailing slashes fail to match path
export default {
    children: [
        {
            path: "invoices",
            name: "invoices",
            component: Invoices,
            meta: {
                requiresAuth: true,
                title: "lang.invoices",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["invoices.read"],
            },
        },
        {
            path: "invoices/create/:id(\\d+)",
            name: "invoices_create",
            component: CreateInvoice,
            meta: {
                requiresAuth: true,
                title: "lang.create_invoice",
                restrict_by_login_type: ["employee"],
                restrict_by_permission: ["invoices.read", "invoices.create"],
            },
        },
        {
            path: "invoices/:id(\\d+)",
            name: "invoice",
            component: Invoice,
            meta: {
                requiresAuth: true,
                title: "lang.invoice",
                restrict_by_login_type: ["employee", "customer"],
                restrict_by_permission: ["invoices.read"],
            },
        },
    ],
};
